import { IAuthRoles } from '@auth/firebase/interfaces';
import { getDomainRole } from '@utils/site';
import { atom } from 'jotai';
import { Role } from '../../access/definitions';
import { getRole } from '@auth/definitions';

const initialRole = import.meta.env.VITE_DEFAULT_ROLE as Role ?? getDomainRole('user_band0').role

const _roleAtom = atom<IAuthRoles>({
    role: initialRole,
    other_roles: []
});

export const roleAtom = atom(
    (get) => get(_roleAtom),
    (get, set, value?: IAuthRoles) => {
        if (value)
            set(_roleAtom, value)
    }
)

roleAtom.onMount = (setAtom) => {
    if (import.meta.env.VITE_DEFAULT_ROLE)
        return
    const f = async () => {
        setAtom(await getRole())
    }
    f()
}
